(() => {
  const shouldRun = document.body?.classList?.contains('template-index');
  if (!shouldRun) return;

  const band = document.querySelector('[data-home-yellow-band]');
  if (!band) return;

  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  const getTop = (el) => {
    const rect = el.getBoundingClientRect();
    return rect.top + window.scrollY;
  };

  const getBottom = (el) => {
    const rect = el.getBoundingClientRect();
    return rect.bottom + window.scrollY;
  };

  let metrics = null;
  let rafId = null;
  const animatedState = {
    progress: 0,
    peak: 0,
    fade: 0,
  };
  const targetState = {
    progress: 0,
    peak: 0,
    fade: 0,
  };

  const update = () => {
    const startEl = document.querySelector('.landing-hero__headline-row');
    const endEl =
      document.querySelector('.featured-bundle') ||
      document.querySelector('.launch-scent-overview');
    const valuePropEl = document.querySelector('.value-proposition');
    const valuePropGridEl = document.querySelector('.value-proposition__grid');
    if (!startEl || !endEl) return;

    const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    let originalTop = Math.max(0, Math.round(getTop(startEl) - viewportHeight * 0.03));
    const bottomExtension = viewportHeight * 0.4;
    let originalBottom = Math.max(originalTop, Math.round(getBottom(endEl) + bottomExtension));
    let height = Math.max(0, originalBottom - originalTop);

    let peak = originalTop + height * 0.42;
    let peakRange = Math.max(height * 0.35, 1);
    if (valuePropEl && height > 0) {
      const peakSourceEl = valuePropGridEl || valuePropEl;
      const peakSourceRect = peakSourceEl.getBoundingClientRect();
      peak = peakSourceRect.top + window.scrollY + peakSourceRect.height / 2;
      peakRange = Math.max(peakSourceRect.height * 1.6, viewportHeight * 0.8, 1);
      // Hug value-prop with equal padding so fade zones stay on-page and peak sits at 50%
      const vpHalf = peakSourceRect.height / 2;
      const pad = Math.max(peakSourceRect.height * 0.9, viewportHeight * 0.38);
      originalTop = Math.round(peak - vpHalf - pad);
      // Stop at value-prop's bottom edge, or the white fade leaks into the next section
      originalBottom = Math.min(Math.round(peak + vpHalf + pad), Math.round(getBottom(valuePropEl)));
      height = originalBottom - originalTop;
    }

    metrics = {
      top: originalTop,
      bottom: originalBottom,
      height,
      peak,
      peakRange,
    };

    band.style.top = `${originalTop}px`;
    band.style.height = `${height}px`;
    band.style.setProperty('--home-band-peak-y', `${clamp(((peak - originalTop) / Math.max(height, 1)) * 100, 0, 100).toFixed(2)}%`);
    updateScrollState();
  };

  const scheduleRender = () => {
    if (rafId != null) return;
    rafId = window.requestAnimationFrame(render);
  };

  const render = () => {
    rafId = null;

    animatedState.progress += (targetState.progress - animatedState.progress) * 0.14;
    animatedState.peak += (targetState.peak - animatedState.peak) * 0.16;
    animatedState.fade += (targetState.fade - animatedState.fade) * 0.14;

    band.style.setProperty('--home-band-progress', animatedState.progress.toFixed(4));
    band.style.setProperty('--home-band-peak', animatedState.peak.toFixed(4));
    band.style.setProperty('--home-band-fade', animatedState.fade.toFixed(4));

    if (
      Math.abs(targetState.progress - animatedState.progress) > 0.001 ||
      Math.abs(targetState.peak - animatedState.peak) > 0.001 ||
      Math.abs(targetState.fade - animatedState.fade) > 0.001
    ) {
      scheduleRender();
    }
  };

  const updateScrollState = () => {
    if (!metrics || metrics.height <= 0) return;

    const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    const scrollAnchor = window.scrollY + viewportHeight * 0.46;
    const progress = clamp((scrollAnchor - metrics.top) / Math.max(metrics.height, 1), 0, 1);
    const peakStrength = Math.pow(
      clamp(1 - Math.abs(scrollAnchor - metrics.peak) / metrics.peakRange, 0, 1),
      1.35
    );
    const fadeStrength = Math.pow(Math.sin(progress * Math.PI), 1.12);

    targetState.progress = progress;
    targetState.peak = peakStrength;
    targetState.fade = fadeStrength;
    scheduleRender();
  };

  update();
  window.addEventListener('resize', update, { passive: true });
  window.addEventListener('load', update, { passive: true });
  window.addEventListener('scroll', updateScrollState, { passive: true });
})();
